import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

export const SliderAnimatedBar = styled(Box)`
  height: 1px;
  border-top: 2px ${theme.wild.color.nova.transparency.black[20]} solid;
  padding: 0 0 32px;
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: -2px;
    left: 0;
    border-top: 2px solid ${theme.wild.color.nova.brand.accent[80]};
  }
  &.animated {
    &:before {
      animation: ${(props) => `bar ${props.delay || 5}s linear forwards 1`};
    }
  }

  &.paused {
    &:before {
      width: 50%;
      transform: translateX(${(props) => `${props.curIndex * 100}%`});
    }
  }
`

export const SliderWrapper = styled(Flex)`
  border-radius: 8px;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  aspect-ratio: 327 / 429;
  padding: 30px;

  @media (min-width: 480px) {
    padding: 32px 32px;
  }

  @media (min-width: 1024px) {
    max-width: 344px;
    max-height: 451px;
    padding: 16px;
  }

  @media (min-width: 1440px) {
    padding: 32px 32px;
  }

  .slick-slider {
    flex: 1;

    .slick-list {
      height: 100%;
    }
  }
`
export const SliderWrapperBasic = styled(Flex)`
  width: 100%;

  @media (min-width: 1024px) {
    //max-width: 344px;
  }
`

export const SliderWrapperStat = styled(Flex)`
  flex-direction: column;
  align-items: start;
  gap: 16px;
  text-align: left;
  width: 90%;
`

export const SliderFooter = styled(Flex)`
  flex-direction: column;
`

export const SliderWrapperSlide = styled(Flex)`
  margin: auto;
  height: auto;

  flex-direction: column;

  .stat {
    font-size: 18vw !important;
    @media (min-width: 768px) {
      //font-size: 74px !important;
      font-size: 8.5vw !important;
    }
    @media (min-width: 1024px) {
      font-size: 72px !important;
    }
  }

  .copy {
    @media (min-width: 1024px) and (max-width: 1279px) {
      font-size: 14px !important;
    }
  }

  span {
    color: currentColor;
  }
`
